import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Http, Response, Headers, RequestOptions, ResponseContentType} from '@angular/http';
import {OilChange, Provider, OilChangeInfo, DateInterval}  from '../pages/gestion-park/model/index';
import {GlobalService} from '../providers/global.config'
import { User } from '../objects/real-time';
import {Events } from 'ionic-angular';

@Injectable()
export class OilChangeService {
    currentuser:User;
dns:string;
    constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
        this.currentuser=JSON.parse(localStorage.getItem('currentuser'));
      this.dns = globalService.getDns();

    }
    getListOilChanges(idVehicule: number): Observable<OilChangeInfo[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'oilChanges/list/' + idVehicule, {headers: headers}).map(res => res.json());
    }

    getProviders(type: string): Observable<Provider[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'providers/listByType?type=' + type, {headers: headers}).map(res => res.json());
    }

    delete(id: number): Observable<Boolean> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.delete(this.dns + 'oilChanges/' + id, {headers: headers}).map(res => res.json());
    }

    readData(idVehicule: number, fileName: string): Observable<OilChangeInfo[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'oilChanges/readData/' + idVehicule + '?fileName=' + fileName, {headers: headers}).map(res => res.json());
    }

    public getDataInExcel(idVehicule: number, date: DateInterval): Observable<Blob> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
        let body = JSON.stringify(date);
        return this._http.post(this.dns + 'oilChanges/exportExcel/' + idVehicule, date, options).map(res => res.blob());
    }

    public add(oilChange: OilChange, idVehicule: number, idProvider: number, providerName: string): Observable<OilChangeInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(oilChange);
        return this._http.post(this.dns + 'oilChanges/?idVehicule=' + idVehicule + '&idProvider=' + idProvider + '&providerName=' + providerName, oilChange, options).map(res => res.json());
    }

    public update(oilChange: OilChange, idProvider: number, providerName: string): Observable<OilChangeInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(oilChange);
        return this._http.put(this.dns + 'oilChanges/?idProvider=' + idProvider + '&providerName=' + providerName, oilChange, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/providers/oil-change.service.ts